import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"margin-top":"-55px !important"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mb-1" }, "Avalúos", -1)
const _hoisted_4 = { class: "fs-base mb-2" }
const _hoisted_5 = { class: "row avaluos_m-a" }
const _hoisted_6 = { class: "row mt-8 mb-6 avaluos_m-a" }
const _hoisted_7 = { class: "col-xs-12 mb-1 mb-md-0 col-md-2 col-lg-2 serch-flex-content" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_9 = { class: "mb-1 mb-md-0 col-md-2 col-lg-2 col-xs-12" }
const _hoisted_10 = { class: "mb-1 mb-md-0 col-md-2 col-lg-2 col-xs-12" }
const _hoisted_11 = { class: "mb-1 mb-md-01 col-md-1 col-lg-1 col-xs-12" }
const _hoisted_12 = {
  key: 0,
  class: "col-sm-1 col-md-1 col-lg-1 col-xs-12 offset-md-1"
}
const _hoisted_13 = { class: "mb-1 col-md-2 col-lg-2 col-xs-12 offset-md-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "isax-directbox-receive" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Descargar"),
  /*#__PURE__*/_createElementVNode("span", null, " listado")
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "mb-1 mb-md-0 col-md-2 col-lg-2 col-xs-12"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Crear"),
  /*#__PURE__*/_createElementVNode("span", null, " avalúo")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "row avaluos_m-a" }
const _hoisted_21 = { class: "row avaluos_m-a" }
const _hoisted_22 = {
  src: "media/icons/iconsax/blue_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_23 = {
  src: "media/icons/iconsax/blue_light_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_24 = {
  src: "media/icons/iconsax/red_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_25 = {
  src: "media/icons/iconsax/green_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_26 = { class: "row avaluos_m-a" }
const _hoisted_27 = { class: "px-3" }
const _hoisted_28 = {
  key: 0,
  class: "row align-items-center py-3 px-3 m-0 border border-top-0 border-gray-600 rounded-bottom bg-gray footer-position-table"
}
const _hoisted_29 = { class: "col-sm-12 col-md-6 mb-3 mb-md-0 d-flex flex-row align-items-center fs-sm" }
const _hoisted_30 = { class: "me-2" }
const _hoisted_31 = { class: "col-sm-12 col-md-6 text-end" }
const _hoisted_32 = {
  id: "kt_referre_dusers_tab_content_pagination",
  class: "tab-content"
}
const _hoisted_33 = { class: "pagination justify-content-end fs-xs" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "page-link"
}
const _hoisted_36 = {
  key: 0,
  class: "row avaluos_m-a"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fs-5" }, "Sin resultados")
], -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ModalCreateAppraisal = _resolveComponent("ModalCreateAppraisal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString($setup.total) + " registros", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-solid ps-14 inputSearch fs-base me-0",
            placeholder: "Buscar",
            onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.search())),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.wordToSearch) = $event))
          }, null, 544), [
            [_vModelText, $setup.wordToSearch]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            "data-kt-subscription-table-filter": "search",
            name: "Estatus",
            autocomplete: "off",
            class: "form-select form-select-solid select2-hidden-accessible",
            modelValue: $setup.selectedStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedStatus) = $event)),
            style: {"margin-left":"5px"}
          }, {
            default: _withCtx(({ value, errorMessage, handleChange }) => [
              _createVNode(_component_el_select, {
                class: "w-100",
                name: "",
                value: value,
                "model-value": value,
                "onUpdate:modelValue": handleChange,
                loading: $setup.loading,
                size: "large",
                onChange: $setup.search
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_el_option, {
                    key: 'Estatus',
                    label: 'Estatus',
                    value: 'Estatus'
                  })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listStatus, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.status,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Field, {
            "data-kt-subscription-table-filter": "search",
            name: "Marca",
            autocomplete: "off",
            class: "form-select form-select-solid select2-hidden-accessible",
            modelValue: $setup.selectedBrand,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedBrand) = $event)),
            style: {"margin-left":"5px"}
          }, {
            default: _withCtx(({ value, errorMessage, handleChange }) => [
              _createVNode(_component_el_select, {
                class: "w-100",
                name: "",
                value: value,
                "model-value": value,
                "onUpdate:modelValue": handleChange,
                loading: $setup.loading,
                size: "large",
                onChange: $setup.search
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_el_option, {
                    key: 'Marca',
                    label: 'Marca',
                    value: 'Marca'
                  })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listBrands, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Field, {
            "data-kt-subscription-table-filter": "search",
            name: "Año",
            autocomplete: "off",
            class: "form-select form-select-solid select2-hidden-accessible",
            modelValue: $setup.selectedYear,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedYear) = $event)),
            style: {"margin-left":"5px"}
          }, {
            default: _withCtx(({ value, errorMessage, handleChange }) => [
              _createVNode(_component_el_select, {
                class: "w-100",
                name: "",
                value: value,
                "model-value": value,
                "onUpdate:modelValue": handleChange,
                loading: $setup.loading,
                size: "large",
                onChange: $setup.search
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_el_option, {
                    key: 'Año',
                    label: 'Año',
                    value: 'Año'
                  })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listYears, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (!$setup.can('Crear cita'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary fs-base fw-normal px-3 btn-responsive btn-download",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.download && $setup.download(...args)))
          }, _hoisted_16)
        ]),
        ($setup.can('Crear cita'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary fs-base fw-normal px-3 btn-responsive btn-create",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.openModalCreateAppraisal && $setup.openModalCreateAppraisal(...args)))
              }, _hoisted_19)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_DataTable, {
          "table-data": $setup.tableRows,
          loading: $setup.loading,
          "table-header": $setup.tableHeader,
          "enable-items-per-page-dropdown": false,
          rowsPerPage: parseInt($setup.showing)
        }, _createSlots({
          "cell-status": _withCtx(({ row: data }) => [
            _withDirectives(_createElementVNode("img", _hoisted_22, null, 512), [
              [_vShow, data.status == 'Negociación']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [
              [_vShow, data.status == 'Documentación']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [
              [_vShow, data.status == 'Cancelado']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [
              [_vShow, data.status == 'Comprado']
            ]),
            _createTextVNode(" " + _toDisplayString(data.status), 1)
          ]),
          _: 2
        }, [
          ($setup.userRole.name == 'Administrador' || $setup.userRole.name == 'Coordinador de agencia')
            ? {
                name: "cell-appraiser",
                fn: _withCtx(({ row: data }) => [
                  _createVNode(_component_router_link, {
                    to: '/appraisals/' + data.valuation_id,
                    class: "text-gray-800 text-hover-primary mb-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.appraiser), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                key: "0"
              }
            : undefined,
          ($setup.userRole.name == 'Valuador' || $setup.userRole.name == 'Valuador a domicilio' || $setup.userRole.name == 'Valuador de agencia')
            ? {
                name: "cell-customer_name",
                fn: _withCtx(({ row: data }) => [
                  _createVNode(_component_router_link, {
                    to: '/appraisals/' + data.valuation_id,
                    class: "text-gray-800 text-hover-primary mb-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.customer_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                key: "1"
              }
            : undefined
        ]), 1032, ["table-data", "loading", "table-header", "rowsPerPage"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          ($setup.total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("span", _hoisted_30, "Elementos por página:", 512), [
                    [_vShow, $setup.links.length > 0]
                  ]),
                  _withDirectives(_createVNode(_component_Field, {
                    name: "pages",
                    autocomplete: "off",
                    class: "form-select form-select-solid select2-hidden-accessible pageNumber",
                    modelValue: $setup.showing,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.showing) = $event))
                  }, {
                    default: _withCtx(({ value, errorMessage, handleChange }) => [
                      _createVNode(_component_el_select, {
                        name: "pages",
                        value: value,
                        "model-value": value,
                        "onUpdate:modelValue": handleChange,
                        loading: $setup.loading,
                        class: _normalizeClass([_ctx.pageNumber, "w-75px"]),
                        onChange: $setup.showingSet
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            class: _normalizeClass(_ctx.fs-_ctx.sm),
                            value: 10,
                            selected: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("10")
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createVNode(_component_el_option, {
                            class: _normalizeClass(_ctx.fs-_ctx.sm),
                            value: 25,
                            selected: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("25")
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createVNode(_component_el_option, {
                            class: _normalizeClass(_ctx.fs-_ctx.sm),
                            value: 50,
                            selected: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("50")
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          _createVNode(_component_el_option, {
                            class: _normalizeClass(_ctx.fs-_ctx.sm),
                            value: 100,
                            selected: true
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("100")
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "class", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]), [
                    [_vShow, $setup.links.length > 0]
                  ]),
                  _withDirectives(_createElementVNode("span", { class: "w-25 fs-sm" }, " " + _toDisplayString($setup.from) + " - " + _toDisplayString($setup.to) + " de " + _toDisplayString($setup.total), 513), [
                    [_vShow, $setup.links.length > 0]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("div", _hoisted_32, [
                    _createElementVNode("ul", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.links, (link, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          onClick: ($event: any) => ($setup.getPagination(link)),
                          key: index,
                          class: _normalizeClass([link ? 'page-item' : '', link.active ? 'active' : '', link.url == null ? 'disabled' : ''])
                        }, [
                          (link.url != null)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_35, _toDisplayString(link.label.includes("Anterior")? "<" : link.label.includes("Siguiente") ? ">" : link.label), 1))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_34))
                      }), 128))
                    ])
                  ], 512), [
                    [_vShow, $setup.links.length > 0]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.noResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalCreateAppraisal, {
      ref: "refModalCreateAppraisal",
      onUpdateList: _cache[8] || (_cache[8] = ($event: any) => ($setup.getData()))
    }, null, 512)
  ]))
}